import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { z } from "zod"

import { AssociatedTestTemplatesContainer } from "@/screens/Products/components/Product/Quality/TestTemplates/components/AssociatedTestTemplatesContainer"

const SearchParamsValidator = z.object({})

export const PRODUCT_TEST_TEMPLATES_ROUTE_PATH = "/app/product/$productId/edit/_layout/quality/_layout/templates"
export const PRODUCT_TEST_TEMPLATES_CONCISE_ROUTE_PATH = "/app/product/$productId/edit/quality/templates"

export const Route = createFileRoute(PRODUCT_TEST_TEMPLATES_ROUTE_PATH)({
  component: RouteComponent,
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams([])],
  },
})

function RouteComponent() {
  return <AssociatedTestTemplatesContainer />
}
